import React, { useMemo } from 'react';
import { Dropdown, Menu, Button } from 'antd';
import {
  DownloadOutlined,
  PrinterOutlined,
  ReloadOutlined,
  ThunderboltOutlined,
  MenuFoldOutlined
} from '@ant-design/icons';

type MoreOptionsMenuProps = {
  onDownload: () => void;
  onPrint: () => void;
  onRefresh: () => void;
  onRefreshPrint: () => void;
  disableDownloadPrint: boolean;
  disableRefresh: boolean;
};

const MoreOptionsMenu: React.FC<MoreOptionsMenuProps> = ({
  onDownload,
  onPrint,
  onRefresh,
  onRefreshPrint,
  disableDownloadPrint,
  disableRefresh
}) => {
  const menuItems = useMemo(
    () => [
      { key: 'download', label: 'Download', icon: <DownloadOutlined />, onClick: onDownload, disabled: disableDownloadPrint },
      { key: 'print', label: 'Print', icon: <PrinterOutlined />, onClick: onPrint, disabled: disableDownloadPrint },
      { key: 'refresh', label: 'Refresh', icon: <ReloadOutlined />, onClick: onRefresh, disabled: disableRefresh },
      { key: 'refresh_print', label: 'Refresh & Print', icon: <ThunderboltOutlined />, onClick: onRefreshPrint, disabled: disableDownloadPrint || disableRefresh }
    ],
    [onDownload, onPrint, onRefresh, onRefreshPrint, disableDownloadPrint, disableRefresh]
  );

  const renderMenuItems = (items: typeof menuItems) => (
    <Menu>
      {items.map(({ key, label, icon, onClick, disabled }) => (
        <Menu.Item key={key} icon={icon} onClick={onClick} disabled={disabled} title={label}>
          {label}
        </Menu.Item>
      ))}
    </Menu>
  );

  return (
    <Dropdown overlay={renderMenuItems(menuItems)} trigger={['click']}>
      <Button aria-label="More Options"><MenuFoldOutlined /></Button>
    </Dropdown>
  );
};

export default MoreOptionsMenu;
